import React from 'react';
import { emptyGroup, emptyCriterion } from './conditionModel';
import ConditionRow from './ConditionRow';
import '../timeline.css';

// Segment condition builder. Renders flat (one group, no group chrome) by default;
// reveals the outer ALL/ANY + per-group headings only once there is more than one
// group. State is always the parsed draft {groups, conditionOperator}.
export default function SegmentConditionBuilder({ draft, onChange, attrOptions = [], productOptions = [] }) {
  const { groups, conditionOperator } = draft;
  const grouped = groups.length > 1;
  const emit = (next) => onChange({ ...draft, ...next });
  const setGroups = (gs) => emit({ groups: gs });
  const patchGroup = (groupIndex, patch) =>
    setGroups(groups.map((group, i) => (i === groupIndex ? { ...group, ...patch } : group)));
  const patchCriterion = (groupIndex, criterionIndex, next) =>
    patchGroup(groupIndex, {
      criteria: groups[groupIndex].criteria.map((criterion, i) => (i === criterionIndex ? next : criterion)),
    });
  const addCriterion = (groupIndex) =>
    patchGroup(groupIndex, { criteria: [...groups[groupIndex].criteria, emptyCriterion()] });
  const removeCriterion = (groupIndex, criterionIndex) =>
    patchGroup(groupIndex, { criteria: groups[groupIndex].criteria.filter((_, i) => i !== criterionIndex) });
  const addGroup = () => setGroups([...groups, emptyGroup()]);
  const removeGroup = (groupIndex) => setGroups(groups.filter((_, i) => i !== groupIndex));

  const opSelect = (label, value, onCh) => (
    <select aria-label={label} value={value} onChange={(e) => onCh(e.target.value)}>
      <option value="AND">ALL</option>
      <option value="OR">ANY</option>
    </select>
  );

  return (
    <div className="seg-builder">
      {grouped && (
        <label className="tp-lbl">
          Include a customer who matches{' '}
          {opSelect('Match groups operator', conditionOperator, (v) => emit({ conditionOperator: v }))}{' '}
          of these groups
        </label>
      )}

      {groups.map((group, groupIndex) => (
        <div className={grouped ? 'seg-group' : 'seg-group seg-group--flat'} key={groupIndex}>
          <div className="seg-ghead">
            {grouped ? `Group ${groupIndex + 1} — match ` : 'Include a customer who matches '}
            {opSelect(
              grouped ? `Group ${groupIndex + 1} operator` : 'Group operator',
              group.criteriaOp,
              (v) => patchGroup(groupIndex, { criteriaOp: v }),
            )}{' '}
            of:
            {grouped && (
              <button type="button" className="tp-move" onClick={() => removeGroup(groupIndex)}>remove group</button>
            )}
          </div>

          {group.criteria.map((criterion, criterionIndex) => (
            <ConditionRow
              key={criterionIndex}
              criterion={criterion}
              attrOptions={attrOptions}
              productOptions={productOptions}
              idLabel={`Group ${groupIndex + 1} condition ${criterionIndex + 1}`}
              canRemove
              onChange={(next) => patchCriterion(groupIndex, criterionIndex, next)}
              onRemove={() => removeCriterion(groupIndex, criterionIndex)}
            />
          ))}

          <button type="button" className="tp-add" onClick={() => addCriterion(groupIndex)}>+ Add condition</button>
        </div>
      ))}

      <button type="button" className="tp-add" onClick={addGroup}>+ Add group</button>
    </div>
  );
}
